/**
 * Handles all jump container
 * @module jump container
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'jumpContainer';
export const DEFAULTS = {
  updateURL: false,
  navItems: '.js-jump-container-nav a',
  content: '.js-jump-container-content'
};


function jump($parent, $el, opts, e, el) {
  e.preventDefault();

  var hash = el.hash,
    $target = $(hash);

  var topPos = $target[0].offsetTop;
  $parent.find(opts.content).scrollTop(topPos-10);
  $target.focus();

}

function setEventListeners($parent, opts) {
  $parent.find(opts.navItems).on('click', function(e) {
    jump($parent, $(this), opts, e, this);
  });
}

/**
 * Initializes jumpContainer.
 * @param {HTMLElement} el - button /element that opens jumpContainer
 * @param {Object} options - Options used for wiring up the jumpContainer
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function jumpContainer(el, options = {}, { deregister }) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, jumpContainer);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/jump-container.js